<template>
  <v-menu
    v-model="visibility"
    offset-y
    nudge-bottom="10"
    :close-on-content-click="false"
    allow-overflow
  >
    <template v-slot:activator="{ on }">
      <BlackBtn
        class="mx-1 black-btn"
        v-on="on"
      >
        {{ label }}：
        <span style="font-weight:bold">{{ value }} {{ suffix }}</span>
      </BlackBtn>
    </template>
    <v-list>
      <v-list-tile>
        <v-form
          class="d-flex"
          @submit.prevent="submitHandler"
        >
          <NumberField
            ref="submitField"
            v-model="data"
            :messages="[message]"
            color="metalBlue"
            class="mx-2"
          />
          <v-btn
            icon
            type="submit"
            class="pa-0 ma-0 submit-button"
            color="success"
          >
            <v-icon>
              mdi-check
            </v-icon>
          </v-btn>
        </v-form>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { NumberField } from '@/components/input'
import { BlackBtn } from '@/components/ui'
export default {
  components: {
    BlackBtn,
    NumberField
  },
  props: {
    label: {
      type: String,
      default: () => ''
    },
    suffix: {
      type: String,
      default: () => ''
    },
    value: {
      type: Number,
      default: () => null
    },
    min: {
      type: Number,
      default: () => null
    },
    max: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      data: null,
      visibility: false
    }
  },
  computed: {
    message () {
      return `${this.min} ~ ${this.max || ''}`
    }
  },
  watch: {
    visibility (value) {
      if (value) {
        this.data = this.value
        setTimeout(() => {
          const target = this.$refs.submitField.$refs.numField
          target.focus()
          target.$refs.input.select()
        }, 100)
      }
    }
  },
  methods: {
    submitHandler () {
      if (this.data) {
        const result = Math.min(Math.max(this.data, this.min), this.max || 99999)
        this.$emit('input', result)
      }
      this.visibility = false
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-button{
  height: 85px;
  width: 125px;
}
/deep/.theme--light.v-list{
  padding-top: 15px;
  width: 160px;
  height: 80px;
  overflow-y: hidden;
  overflow-x: hidden;
}
/deep/.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea{
  text-align: center;
}
/deep/.v-messages__message{
  text-align: center;
}
/deep/.v-list__tile{
  padding: 0;
}
/deep/.v-btn__content{
  width: auto;
}
/deep/.v-btn__content{
  font-size: 1rem;
}
</style>
